import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import { useContext, useEffect, useState } from 'react';
import UserProfile from './UserProfile';
import BillingPage from './BillingPage';
import { UserContext } from '../Context/UserContext';
import { pricingData } from '../Common/PricingData';
import { handleRazorpayPayment } from '../Utils/Razorpay';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/FooterComponent';
import { sentryLog } from '../Utils/SentryLog';
import { getLqzyParams } from '../Utils/GetLqzyParams';
import { toast } from 'react-toastify';
/* global gtag */
/* global gtag_report_conversion */

const APP_BASE_URL = process.env.NODE_ENV === 'development' 
    ? "http://localhost:3000" 
    : "https://www.easyimagetotext.com";

const API_BASE_URL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL;

const lemonSqzyQueryParams = getLqzyParams();

function PricingPage({ isIndianUser }){

    const { user, setUser } = useContext(UserContext);
    
    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
    const [userDiscountCode, setUserDiscountCode] = useState("");
    const [isDiscountApplied, setIsDiscountApplied] = useState(false);
    const [fromExtension, setFromExtension] = useState(false);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    const navigate = useNavigate();

    isShowConsole && console.log('pricing page user check: ', user);
    isShowConsole && console.log("Current Path:", location.pathname); 

    useEffect(() => {
        const planAmount = localStorage.getItem("pendingPlanAmount");
        const planType = localStorage.getItem("pendingPlanType");
        const pendingPaypalPlanLink = localStorage.getItem("pendingPaypalPlanLink");

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('source') === 'extension') {
            sessionStorage.setItem('fromExtension', 'true');
            setFromExtension(true);
        }
      
        if (planAmount && planType) {
            try {
                handleRazorpayPayment(Number(planAmount), planType, setUser, openContactForm);
            } catch (err) {
                isShowConsole && console.error('handleRazorpayPayment failed in useEffect:', err);
                sentryLog(`PricingPage.js - useEffect RazorpayPayment failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
            }
            localStorage.removeItem("pendingPlanAmount");
            localStorage.removeItem("pendingPlanType");
        }
        if(pendingPaypalPlanLink){
            try {
                window.open(
                    pendingPaypalPlanLink,
                    "_blank"
                );
            } catch (err) {
                isShowConsole && console.error('pending paypal plan link failed to open in useEffect in PricingPage.js:', err);
                sentryLog(`PricingPage.js - useEffect pending paypal plan link open failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
            }
            localStorage.removeItem("pendingPaypalPlanLink");
        }
    }, []);

    const showSuccessToast = () => {
      try{
        toast.success(
          <div className='verificationSuccessToast'>
            <span>
                Plan upgraded! 🎉  
            </span>
          </div>,
          {
            className: "verificationSuccessToastContainer",
            autoClose: 4000, 
            closeButton: false,
            onClose: () => {
                if (sessionStorage.getItem('fromExtension') === 'true') {
                    sessionStorage.removeItem('fromExtension');
                    setTimeout(() => window.close(), 100); 
                }
            }
          }
        );
      }catch(err){
        isShowConsole && console.error("error in showSuccessToast: ", err);
        sentryLog(`Razorpay.js - showSuccessToast failed: ${err?.message || err}`);
      }
    }

    useEffect(() => {
        const shouldNotifyUserUpgrade = localStorage.getItem("shouldNotifyUserUpgrade");

        if(shouldNotifyUserUpgrade === 'true'){
            showSuccessToast();
            localStorage.removeItem("shouldNotifyUserUpgrade");
        }
        
    }, [user])

    const openContactForm = e => {
        try{
            navigate(`/contact-us${lemonSqzyQueryParams}`);
        }catch(err){
            isShowConsole && console.error('error in openContactForm method: ', err);
            sentryLog(`PricingPage.js - openContactForm failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const applyDiscountCode = e => {
        try{
            setIsDiscountApplied(true);
        }catch(err){
            isShowConsole && console.error('error in applyDiscountCode method: ', err);
            sentryLog(`PricingPage.js - applyDiscountCode failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const openSheetsExtensionPricingPage = e => {
        try{
            window.open(
                'https://www.easyimagetotext.com/sheets-extension-pricing',
                "_blank"
            );
        }catch(err){
            isShowConsole && console.error('error in openSheetsExtensionPricingPage method: ', err);
            sentryLog(`PricingPage.js - openSheetsExtensionPricingPage failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const pricingElements = (user !== undefined) ? pricingData.map((ele, idx) => {

        const isFree = ele.plan === 'Free';
        const perVal = ele.plan === "Pro Weekly" ? 'week' : ele.plan === 'Pro Monthly' ? 'month' : ele.plan === 'Pro Yearly' ? 'year' : '';
        const billingPeriodInfo = ele.plan === "Pro Weekly" ? 'weekly' : ele.plan === 'Pro Monthly' ? 'monthly' : ele.plan === 'Pro Yearly' ? 'yearly' : '';
        const extractionMsg = ele.plan === 'Free' ? (ele.features.usageLimit + ' extractions per day') : (ele.features.usageLimit + ' Extractions & Translations');
        const validityMsg = ele.plan === "Pro Weekly" ? 'Valid for 7 days' : ele.plan === 'Pro Monthly' ? 'Valid for 30 days' : ele.plan === 'Pro Yearly' ? 'Valid for 365 days' : '';
        const billingMsg = ele.plan === "Pro Weekly" ? 'Valid for 7 days' : ele.plan === 'Pro Monthly' ? 'Billed monthly' : ele.plan === 'Pro Yearly' ? 'Billed yearly' : '';

        const showActiveMsg = (
            (isFree && user && !user.isPremium) ||
            (user?.isPremium && user?.planType === ele.plan)
          );

        const currencySymbol = "$";//isIndianUser === null || isIndianUser ? '₹' : '$';
        const rate = ele.foreignRate;//isIndianUser === null || isIndianUser ? ele.rate : ele.foreignRate;

        const showTagline = ele.plan === 'Pro Monthly' || ele.plan === 'Pro Yearly';
        const tagLine = ele.plan === 'Pro Monthly' ? 'Most popular' : ele.plan === 'Pro Yearly' ? 'Best Value' : '';

        return(
            <div className={`planContainer ${ele.plan}`} key={idx}>
                {showTagline && <div className='tagLine'>{tagLine.toUpperCase()}</div>}
                <div className='planNameDiv'>
                    <div className='planName'>{ele.plan}</div>
                    {isFree ? (showActiveMsg && <div className={`activeMsg`}>(Active)</div>) : <div className={`activeMsg ${showActiveMsg ? 'show' : 'hide'}`}>(Active)</div>}
                </div>
                {!isFree && (isIndianUser !== null) && <div className={`planRate ${user?.isPremium ? 'premium' : ''}`}>
                    <div className='val'>{currencySymbol}{rate}</div>
                    <div className='duration'>/{perVal}</div>
                </div>}
                {!isFree && <div className={`billingPeriodInfo ${user?.isPremium ? 'premium' : ''}`}>(Billed {billingPeriodInfo})</div>}
                {!isFree && <div className={`upgradeDiv ${user?.isPremium ? 'premium' : ''}`}><div className='upgradeBtn' onClick={async() => {
                    try {
                        //sending to ad conversion tracking
                            let planSelected = ele.plan.toLowerCase();
                            let conversionPlan = planSelected.includes('monthly') ? 'monthly' : planSelected.includes('yearly') ? 'yearly' : null;
                            if (conversionPlan && window.gtag_report_conversion) {
                                gtag_report_conversion(conversionPlan);
                            }
                        //
                        
                        if (isIndianUser === null) return;
                    
                        let paymentLink = `${ele.lemonSqueezyLink}${ele.lemonSqueezyLink.includes('?') ? '&' : '?'}checkout[custom][googleId]=${user?.googleId}&checkout[custom][planType]=${ele.plan}${isDiscountApplied ? ('&checkout[discount_code]='+userDiscountCode) : ''}${fromExtension ? ('&checkout[custom][source]=extension') : ''}`;
                        if(!user){
                            localStorage.setItem("pendingPaypalPlanLink", paymentLink);
                            initiateLogin();
                        }else{
                            window.LemonSqueezy.Url.Open(paymentLink);
                        }
                    } catch (err) {
                        isShowConsole && console.error('upgradeBtn upgrade failed:', err);
                        sentryLog(`PricingPage.js - upgradeBtn upgrade failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
                    }
                }}>Upgrade</div></div>}
                {/* {(ele.plan === 'Pro Monthly') && 
                    <div className='discountContainer'>
                        <div className={`discountWrapper ${isDiscountApplied ? 'applied' : ''}`}>
                            {!isDiscountApplied && <><input type='text' value={userDiscountCode} placeholder='Enter discount code' onChange={(e) => setUserDiscountCode(e.target.value)}/>
                            <button disabled={userDiscountCode === ''} onClick={applyDiscountCode}>Apply</button></>}
                            {isDiscountApplied && <><span className='appliedDiscountMsg'><span className='discountCode'>{userDiscountCode}</span> applied! 🎁</span></>}
                        </div>
                    </div>
                } */}
                <div className='features'>
                    <ul>
                        <li>Image Size upto {ele.features.imageSizeLimit}</li>
                        <li>{extractionMsg}</li> 
                        {!isFree && 
                            <>
                                <li>Priority Email Support</li>
                            </>
                        } 
                    </ul>
                </div>
                {isFree && <div className='partitionNote'><div className='noteHeader'>IMPORTANT:</div><div className='noteContent'>These plans only apply to the current app (Text OCR). <br/><br/>To explore plans and pricings for our Google Sheets Extension (Table OCR), <span className='noteCta' onClick={openSheetsExtensionPricingPage}>please click here</span></div></div>}
            </div>
        )
    }) : null;

    const initiateLifetimeOffer = async(e) => {
        try {
                //sending to ad conversion tracking
                    if (window.gtag_report_conversion) {
                        gtag_report_conversion("lifetime");
                    }
                //
                
                if (isIndianUser === null) return;
                
                let lifetimePlanLemonSqueezyLink = `https://easyimagetotext.lemonsqueezy.com/buy/21069abf-94e5-4530-853d-5ef24e76fd4e?embed=1&enabled=844560`;
                let lifetimePlanLemonSqueezyTestLink = `https://easyimagetotext.lemonsqueezy.com/buy/cbe60bf6-d721-4f5a-9cd3-5ae74773171d?embed=1&enabled=805233`
                let paymentLink = `${lifetimePlanLemonSqueezyLink}${lifetimePlanLemonSqueezyLink.includes('?') ? '&' : '?'}checkout[custom][googleId]=${user?.googleId}&checkout[custom][planType]=Lifetime${fromExtension ? ('&checkout[custom][source]=extension') : ''}`;
                
                if(!user){
                    localStorage.setItem("pendingPaypalPlanLink", paymentLink);
                    initiateLogin();
                }else{
                    window.LemonSqueezy.Url.Open(paymentLink);
                }
            //}
        } catch (err) {
            isShowConsole && console.error('initiateLifetimeOffer failed:', err);
            sentryLog(`PricingPage.js - initiateLifetimeOffer failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }
    
    const initiateLogin = async () => {
      try{
            const query = getLqzyParams();
            await fetch(`${API_BASE_URL}/api/set-redirect`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include', // ✅ critical for session cookie
                body: JSON.stringify({ path: `/pricing${query}` })
            });
      
            window.location.href = `${API_BASE_URL}/auth/google`;
      }catch(err){
          isShowConsole && console.error('error in initiate login method: ', err);
          sentryLog(`PricingPage.js - initiateLogin failed: ${err?.message || err}`);
      }
    }
    
    return(
        fromExtension ? 
            <div className='parentDiv'>
                <div className='mainDiv pricingPage'>
                    <div className='maintenanceBanner'>
                        <div className='wrapper'>
                            <div className="logoDiv">
                                Convert PDF to Google Sheets™
                            </div>
                            <div className='msgContainer'>
                                We're currently performing maintenance on our payment system to bring you new and improved Pro plans. <br/>Please check back soon!
                                <br/><br/><br/>
                                Have questions? Contact us at support@easyimagetotext.com
                            </div>
                        </div>
                    </div>
                </div>
            </div> : 
            <div className='parentDiv'>
                <div className='mainDiv pricingPage'>
                    <div className='header'>
                        <Navbar />
                    </div>
                    <div className='contentDiv'>
                        <div className='containerDiv'>
                            <div className='title'>
                                <div className='main'>Upgrade your plan</div>
                                <div className='sub'>Choose a plan that fits you</div>
                            </div>
                            <div className='contentBox'>
                                <div className='content'>
                                    {pricingElements}
                                </div>
                                <div className='infoNote'>
                                    Lock in now at the best rates! Prices may increase soon.
                                </div>
                            </div>
                        </div>
                    </div>
                    {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
                </div>
                <div className={`lifetimePricingContainer ${user?.planType === 'Lifetime' ? 'lifetimeActive' : ''}`}>
                    <div className='info'>
                        Limited Lifetime Offer! Enjoy all the above premium features for lifetime at $99!
                        <div className='cta'><div className='upgradeBtn' onClick={initiateLifetimeOffer}>Get Lifetime at $99</div></div>
                        {/* Limited Lifetime Offer! Enjoy all the above premium features for lifetime at {isIndianUser ? '₹2999' : '$99'}!
                        <div className='cta'><div className='upgradeBtn' onClick={initiateLifetimeOffer}>Get Lifetime at {isIndianUser ? '₹2999' : '$99'}</div></div> */}
                    </div>
                </div>
                <FooterComponent setShowFeedbackPopup={setShowFeedbackPopup}/>
            </div>
    )
}

export default PricingPage;